// Notifications
// --------------------------------------------------------
import api from '@/lib/api'

const state = {
  digest: {
    active: null,
    frequency: null,
    allLandscapesSelected: null
  }
}

const getters = {
  digest: state => state.digest
}

const mutations = {
  setNotifications(state, {digest}) {
    state.digest = digest
  },
  setDigestData(state, digest) {
    state.digest = digest
  },
  activateDigest(state, active) {
    state.digest.active = active
  },
  digestFrequency(state, frequency) {
    state.digest.frequency = frequency
  }
}

const actions = {
  loadNotificationsOptions({commit}) {
    return api.call('get', '/notifications').then(res => {
      commit('setNotifications', res)
    })
  },
  getDigest() {
    return api.call('get', '/notifications/digest').then(res => {
      return res
    })
  },
  saveDigest({commit}, payload) {
    return api
      .call('put', '/notifications/digest', {digest: payload})
      .then(res => commit('setDigestData', res))
  },
  toggleDigest({commit}, value) {
    commit('activateDigest', value)
    let action = value ? 'activate' : 'deactivate'
    return api.call('post', `/notifications/digest/${action}`)
  },
  digestFrequency({commit}, frequency) {
    commit('digestFrequency', frequency)
    return api.call('post', '/notifications/digest/frequency', {frequency})
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
